import apiClient from '@/shared/services/apiClient'
import type { SolutionAccessResponse, RedeemActivationKeyResponse, UserActivationKeyListResponse } from '../types'

interface ApiResponse<T> {
  success: boolean
  message: string
  data: T
  timestamp: string
}

const activationKeyService = {
  async getSolutionAccess(userId: string): Promise<ApiResponse<SolutionAccessResponse>> {
    const response = await apiClient.get<ApiResponse<SolutionAccessResponse>>(
      '/api/v1/payments/solution-access',
      { params: { userId } }
    )
    return response.data
  },

  async getActivationKeys(userId: string): Promise<ApiResponse<UserActivationKeyListResponse>> {
    const response = await apiClient.get<ApiResponse<UserActivationKeyListResponse>>(
      '/api/v1/payments/activation-keys',
      { params: { userId } }
    )
    return response.data
  },

  async redeemKey(userId: string, code: string): Promise<ApiResponse<RedeemActivationKeyResponse>> {
    const response = await apiClient.post<ApiResponse<RedeemActivationKeyResponse>>(
      '/api/v1/payments/activation-keys/redeem',
      { userId, code }
    )
    return response.data
  },
}

export default activationKeyService
